import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { Dialog } from "component/shared/dialog";
import { Office } from "model/office";
import { styles } from "../style";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	office: Office;
	deleteOfficeDialogIsOpen: boolean;
	hideDeleteOfficeDialog: Function;
	deleteOffice: Function;
}

const component = (props: Props) => {
	const {
		office,
		classes = {},
		deleteOffice,
		deleteOfficeDialogIsOpen,
		hideDeleteOfficeDialog,
	} = props;

	return (
		<Dialog
			open={deleteOfficeDialogIsOpen}
			onClose={() => hideDeleteOfficeDialog()}
		>
			<Mui.DialogTitle>Delete Office</Mui.DialogTitle>
			<Mui.DialogContent className={classes.dialogContent}>
				<Mui.DialogContentText>
					{`Are you sure you want to delete the ${office.name} office?`}
				</Mui.DialogContentText>
			</Mui.DialogContent>
			<Mui.DialogActions className={classes.dialogActions}>
				<Mui.Button onClick={() => hideDeleteOfficeDialog()} variant="outlined" color={"primary"}>
					No
				</Mui.Button>
				<Mui.Button
					onClick={() => deleteOffice()}
					variant="contained"
					color={"primary"}
				>
					Yes
				</Mui.Button>
			</Mui.DialogActions>
		</Dialog>
	);
};

export const DeleteOfficeDialog = withStyles(component, styles);
